import React, { useState } from 'react';
import { ThumbsUpIcon, BookmarkIcon, MessageSquareIcon, SendIcon } from 'lucide-react';
import { toast } from 'sonner';
import { useParams } from 'react-router-dom';
import { cases } from '../data/mockCases';
import { PageHeader } from '../components/common/PageHeader';
export function CaseDetail() {
  const {
    id
  } = useParams();
  const c = cases.find(x => x.id === id) || cases[0];
  const [liked, setLiked] = useState(false);
  const [saved, setSaved] = useState(false);
  const [comment, setComment] = useState('');
  const [comments, setComments] = useState([{
    id: '1',
    u: '小红',
    c: '太励志了！请问雅思怎么备考？',
    likes: 5
  }, {
    id: '2',
    u: '阿熊',
    c: '同方向，求 PS 思路分享。',
    likes: 3
  }]);
  const submit = () => {
    if (!comment.trim()) return;
    setComments([{
      id: Date.now().toString(),
      u: '我',
      c: comment,
      likes: 0
    }, ...comments]);
    setComment('');
    toast.success('评论已发布');
  };
  return <div className="bg-slate-50 min-h-screen pb-24" data-id="element-350">
      <PageHeader title="录取案例" data-id="element-351" />

      <div className="m-3 bg-white rounded-2xl p-4" data-id="element-352">
        <div className="flex items-center gap-3" data-id="element-353">
          <img src={c.avatar} alt="" className="w-12 h-12 rounded-full" data-id="element-354" />
          <div data-id="element-355">
            <div className="font-bold text-slate-800" data-id="element-356">{c.name}</div>
            <div className="text-[11px] text-slate-500" data-id="element-357">
              {c.bgSchool} · {c.bgGpa} · {c.bgLang}
            </div>
          </div>
        </div>
        <div className="mt-3 grid grid-cols-3 gap-2 text-center text-xs" data-id="element-358">
          <div className="bg-blue-50 rounded-lg py-2" data-id="element-359">
            <div className="text-blue-600 font-bold" data-id="element-360">{c.bgGpa}</div>
            <div className="text-[10px] text-slate-500" data-id="element-361">GPA</div>
          </div>
          <div className="bg-blue-50 rounded-lg py-2" data-id="element-362">
            <div className="text-blue-600 font-bold" data-id="element-363">{c.bgLang}</div>
            <div className="text-[10px] text-slate-500" data-id="element-364">语言</div>
          </div>
          <div className="bg-blue-50 rounded-lg py-2" data-id="element-365">
            <div className="text-blue-600 font-bold" data-id="element-366">{c.major}</div>
            <div className="text-[10px] text-slate-500" data-id="element-367">方向</div>
          </div>
        </div>
        <div className="mt-3" data-id="element-368">
          <div className="text-sm font-semibold text-slate-700 mb-2" data-id="element-369">
            最终录取
          </div>
          <div className="flex flex-wrap gap-2" data-id="element-370">
            {c.offers.map(o => <span key={o} className="text-xs bg-emerald-50 text-emerald-700 font-semibold px-2.5 py-1 rounded-full" data-id="element-371">
                🎓 {o}
              </span>)}
          </div>
        </div>
      </div>

      <div className="m-3 bg-white rounded-2xl p-4" data-id="element-372">
        <div className="font-bold text-slate-800 mb-2" data-id="element-373">申请故事</div>
        <p className="text-sm text-slate-600 leading-relaxed" data-id="element-374">
          从大二开始就锁定了海外名校的目标，整个本科四年围绕
          GPA、语言、实习、科研做规划。 GPA 始终保持年级前 10%，雅思一战 7.0
          二战 7.5。两段大厂实习 + 一段教授课题， 使得文书有充足素材。最终在 12
          月底拿到 dream school 的 offer。
        </p>
      </div>

      <div className="m-3 bg-white rounded-2xl p-4" data-id="element-375">
        <div className="font-bold text-slate-800 mb-3 flex items-center justify-between" data-id="element-376">
          <span data-id="element-377">评论 ({comments.length})</span>
        </div>
        <div className="space-y-3" data-id="element-378">
          {comments.map(cm => <div key={cm.id} className="flex gap-2.5" data-id="element-379">
              <div className="w-8 h-8 rounded-full bg-slate-200 flex items-center justify-center text-xs text-slate-600" data-id="element-380">
                {cm.u[0]}
              </div>
              <div className="flex-1" data-id="element-381">
                <div className="text-sm font-semibold text-slate-700" data-id="element-382">
                  {cm.u}
                </div>
                <div className="text-sm text-slate-600 mt-0.5" data-id="element-383">{cm.c}</div>
                <div className="text-[11px] text-slate-400 mt-1" data-id="element-384">
                  {cm.likes} 赞
                </div>
              </div>
            </div>)}
        </div>
      </div>

      {/* 底部互动栏 */}
      <div className="fixed bottom-14 left-1/2 -translate-x-1/2 w-full max-w-[390px] bg-white border-t border-slate-100 px-3 py-2 flex items-center gap-2 z-30" data-id="element-385">
        <input value={comment} onChange={e => setComment(e.target.value)} placeholder="说点什么..." className="flex-1 h-9 px-3 rounded-full bg-slate-100 text-sm outline-none" aria-label="评论" data-id="element-386" />
        <button onClick={() => {
        setLiked(!liked);
        toast(liked ? '已取消' : '已点赞');
      }} className={`p-2 ${liked ? 'text-rose-500' : 'text-slate-500'}`} aria-label="点赞" data-id="element-387">
          <ThumbsUpIcon size={20} fill={liked ? 'currentColor' : 'none'} data-id="element-388" />
        </button>
        <button onClick={() => {
        setSaved(!saved);
        toast(saved ? '已取消收藏' : '已收藏');
      }} className={`p-2 ${saved ? 'text-blue-600' : 'text-slate-500'}`} aria-label="收藏" data-id="element-389">
          <BookmarkIcon size={20} fill={saved ? 'currentColor' : 'none'} data-id="element-390" />
        </button>
        <button onClick={submit} className="w-9 h-9 rounded-full bg-blue-600 text-white flex items-center justify-center" aria-label="发送" data-id="element-391">
          <SendIcon size={16} data-id="element-392" />
        </button>
      </div>
    </div>;
}